export type {
  MessageBarBodySlots,
  MessageBarBodyProps,
  MessageBarBodyState,
  MessageBarBodyContextValues,
} from '@fluentui/react-message-bar';
